import { FC, useEffect, useMemo, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { FInter, FlexBox, useIsMobile } from "@brg/ui";
import { LayoutConst } from 'core/modules';
import { createPortal } from "react-dom";
import { useTranslation } from 'react-i18next';

const DISTANCE_FROM_BEGGINING_PAGE= 65000;

interface LongreadCount {
    active: string;
    idList: string[];
    count: number;
}

interface IProps {
    data: LongreadCount
    isCollectionVote?: boolean
}

const ButtonWrapper = styled(FlexBox)`
  color: #fff;
  opacity: 0.21;
  span {
    font-weight: 600;
  }
  cursor: pointer;
  padding: 0 16px;
  align-items: center;
`

const CountViewerRoot = styled.div <{ visible: boolean, pos: number }>`
  height: 30px;
  position: fixed;
  width: auto;
  background: ${({ theme }) => theme.scrollUp.background};
  right: 0;
  top: ${p => p?.pos}%;
  // padding-top: ${p => p?.pos}%;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: opacity 300ms;
  z-index: 100000;
  cursor: ${({ visible }) => visible ? 'pointer' : 'auto'};

  @media(max-width:${LayoutConst.screen.md}px) {
    display: none;
  }

`

export const LongreadCountViewer: FC <IProps> = ({ data, isCollectionVote }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [scrollBarPos, setScrollBarPos] = useState(0);
  const [isMoreNavbarHeight, setMoreNavbarHeight] = useState(false);

  const maxVal =  useMemo(() => (data.count),[data])
  const bigLongreadView = useMemo(() => (maxVal > 40 ? scrollBarPos > 8 : scrollBarPos > 0), [maxVal, scrollBarPos])

  const [scrolling, setScrolling] = useState(false);
  const visible = useMemo(() => (data && data.active !== '' && data.idList.length > 0 && data.count > 0 && isMoreNavbarHeight && bigLongreadView), [data, isMoreNavbarHeight])

  const onScroll = (e: any) => {
    const prevPos = window.scrollY;
    const distanceFromBegginingPage = Number(window.scrollY * 100);
    setScrolling(true);

    setMoreNavbarHeight(
      distanceFromBegginingPage > ( DISTANCE_FROM_BEGGINING_PAGE * 2)
    )

    setTimeout(() => {
      if (prevPos === window.scrollY) {
        setScrolling(false)
      }
    }, 1000)
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll);
    }
    
  }, [])

  useEffect(() => {

    const pos = (window.scrollY * 100) / document.body.scrollHeight;
    const distanceFromTopScrollToBottom = window.innerHeight - (pos * window.innerHeight / 100);
    const maxPos = isCollectionVote ? 185.01447251491686 : 69.07801193347723 ;
    const maxPosDistance = 100 - ((maxPos * 100) / window.innerHeight);

    setScrollBarPos(distanceFromTopScrollToBottom < maxPos ? maxPosDistance : pos);
  })

  const val =  useMemo(() => {
    if (visible) {
        const idx = data?.idList?.findIndex((i) => i === data?.active) + 1
        if (idx) {
            return idx === data.count ? data.count : idx
        }
    }
  },[visible, data])

  const footer = document.querySelector("#footer-portal")

  if (!footer || !visible) {
    return null;
  }
 
  return createPortal(
    <CountViewerRoot visible={scrolling} pos={scrollBarPos}>
        {visible && (
          <div style={{ padding: '0 23px 0 16px'}}>
            <FInter.SmallText
            style={{ fontSize: '17px', lineHeight: '22px', fontWeight: 700 }} 
            color={theme.viewCount.text}>{`${val} ${t('of')} ${maxVal}`}</FInter.SmallText>
          </div>
        )}
    </CountViewerRoot>,
    footer
  );
};
import { FC, useEffect, useMemo, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { FInter, FlexBox, useIsMobile } from "@brg/ui";
import { LayoutConst } from 'core/modules';
import { createPortal } from "react-dom";
import { useTranslation } from 'react-i18next';

const DISTANCE_FROM_BEGGINING_PAGE= 65000;

interface LongreadCount {
    active: string;
    idList: string[];
    count: number;
}

interface IProps {
    data: LongreadCount
    isCollectionVote?: boolean
}

const ButtonWrapper = styled(FlexBox)`
  color: #fff;
  opacity: 0.21;
  span {
    font-weight: 600;
  }
  cursor: pointer;
  padding: 0 16px;
  align-items: center;
`

const CountViewerRoot = styled.div <{ visible: boolean, pos: number }>`
  height: 30px;
  position: fixed;
  width: auto;
  background: ${({ theme }) => theme.scrollUp.background};
  right: 0;
  top: ${p => p?.pos}%;
  // padding-top: ${p => p?.pos}%;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: opacity 300ms;
  z-index: 100000;
  cursor: ${({ visible }) => visible ? 'pointer' : 'auto'};

  @media(max-width:${LayoutConst.screen.md}px) {
    display: none;
  }

`

export const LongreadCountViewer: FC <IProps> = ({ data, isCollectionVote }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [scrollBarPos, setScrollBarPos] = useState(0);
  const [isMoreNavbarHeight, setMoreNavbarHeight] = useState(false);

  const maxVal =  useMemo(() => (data.count),[data])
  const bigLongreadView = useMemo(() => (maxVal > 40 ? scrollBarPos > 8 : scrollBarPos > 0), [maxVal, scrollBarPos])

  const [scrolling, setScrolling] = useState(false);
  const visible = useMemo(() => (data && data.active !== '' && data.idList.length > 0 && data.count > 0 && isMoreNavbarHeight && bigLongreadView), [data, isMoreNavbarHeight])

  const onScroll = (e: any) => {
    const prevPos = window.scrollY;
    const distanceFromBegginingPage = Number(window.scrollY * 100);
    setScrolling(true);

    setMoreNavbarHeight(
      distanceFromBegginingPage > ( DISTANCE_FROM_BEGGINING_PAGE * 2)
    )

    setTimeout(() => {
      if (prevPos === window.scrollY) {
        setScrolling(false)
      }
    }, 1000)
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll);
    }
    
  }, [])

  useEffect(() => {

    const pos = (window.scrollY * 100) / document.body.scrollHeight;
    const distanceFromTopScrollToBottom = window.innerHeight - (pos * window.innerHeight / 100);
    const maxPos = isCollectionVote ? 185.01447251491686 : 69.07801193347723 ;
    const maxPosDistance = 100 - ((maxPos * 100) / window.innerHeight);

    setScrollBarPos(distanceFromTopScrollToBottom < maxPos ? maxPosDistance : pos);
  })

  const val =  useMemo(() => {
    if (visible) {
        const idx = data?.idList?.findIndex((i) => i === data?.active) + 1
        if (idx) {
            return idx === data.count ? data.count : idx
        }
    }
  },[visible, data])

  const footer = document.querySelector("#footer-portal")

  if (!footer || !visible) {
    return null;
  }
 
  return createPortal(
    <CountViewerRoot visible={scrolling} pos={scrollBarPos}>
        {visible && (
          <div style={{ padding: '0 23px 0 16px'}}>
            <FInter.SmallText
            style={{ fontSize: '17px', lineHeight: '22px', fontWeight: 700 }} 
            color={theme.viewCount.text}>{`${val} ${t('of')} ${maxVal}`}</FInter.SmallText>
          </div>
        )}
    </CountViewerRoot>,
    footer
  );
};
